import Layout from "../_layout.js";
import Poznan from "./pages/_poznan.js";
import Czestochowa from "./pages/_czestochowa.js";

export default function Nieruchomosci(props) {
	let Miasto = props.miasto;
	let Podatek = props.podatek;

	return Miasto == "poznan" ? (
		<Poznan miasto={Miasto} podatek={Podatek} />
	) : Miasto == "czestochowa" ? (
		<Czestochowa miasto={Miasto} podatek={Podatek} />
	) : (
		<Layout miasto={Miasto} podatek={Podatek} />
	);
}
